/* eslint-disable @typescript-eslint/ban-types */
import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'

const basePath = '/salaries'

const salaryEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) => ({
  fetchSalaries: builder.query<any, any>({
    query: (params) => ({
      url: `${basePath}`,
      params,
    }),
    providesTags: ['salaries']
  }),

  fetchSalaryById: builder.query<any, string>({
    query: (id) => `${basePath}/${id}`,
    providesTags: ['salaries']
  }),

  createSalary: builder.mutation<any, any>({
    query: (body) => ({
      url: `${basePath}`,
      method: 'POST',
      body,
    }),
    invalidatesTags: ['salaries']
  }),

  updateSalary: builder.mutation<any, { id: string; body: any }>({
    query: ({ id, body }) => ({
      url: `${basePath}/${id}`,
      method: 'PUT',
      body,
    }),
    invalidatesTags: ['salaries']
  }),

  deleteSalary: builder.mutation<any, string>({
    query: (id) => ({
      url: `${basePath}/${id}`,
      method: 'DELETE',
    }),
    invalidatesTags: ['salaries']
  }),

  fetchSalarySummary: builder.query<any, any>({
    query: (params) => ({
      url: `${basePath}/summary`,
      params,
    }),
    providesTags: ['salaries']
  }),
})

export default salaryEndpoints
